import React from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { Section, SectionHeader } from '../ui/Primitives';
import type { Faq } from '../../data/faqs';
interface FaqsProps {
  id?: string;
  kicker?: string;
  title: string;
  lead?: string;
  items: Faq[];
  tone?: 'white' | 'mist';
}

/**
 * Questions and answers, visible on the page rather than hidden in markup.
 *
 * The answers are rendered in full at all times and the disclosure only changes
 * their visibility, so a crawler or an answer engine reads the complete text
 * whatever the open state.
 */
export function Faqs({
  id = 'faqs',
  kicker = 'Questions',
  title,
  lead,
  items,
  tone = 'white'
}: FaqsProps) {
  const [open, setOpen] = React.useState<number | null>(0);
  return <Section tone={tone} aria-labelledby={`${id}-heading`} data-id="element-337" data-mp="7cfnldvrona3">
      <SectionHeader id={`${id}-heading`} kicker={kicker} title={title} lead={lead} data-id="element-338" data-mp="13vd79kw87qg0" />

      <dl className="mt-10 divide-y divide-line border-y border-line" data-id="element-339" data-mp="z4ddgoielohq">
        {items.map((item, index) => {
        const isOpen = open === index;
        const panelId = `${id}-answer-${index}`;
        return <div key={item.question} data-id="element-340" data-mp="1f0xnoujb0w5i" data-mpi={index}>
              <dt data-id="element-341" data-mp="1f41zoe30gw6q">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-start justify-between gap-6 py-6 text-left" data-id="element-342" data-mp="10d2vdf97ktsy">
                  <span className="font-display text-[19px] leading-snug text-ink sm:text-[21px]" data-id="element-343" data-mp="wb7xkkqhkyjx">
                    {item.question}
                  </span>
                  <span className="mt-1 shrink-0 text-gold" aria-hidden="true" data-id="element-344" data-mp="hg1qrvjkgvpj">
                    {isOpen ? <MinusIcon className="h-5 w-5" data-id="element-345" data-mp="mdjzbkto98x0" /> : <PlusIcon className="h-5 w-5" data-id="element-346" data-mp="2bs88zeavocrc" />}
                  </span>
                </button>
              </dt>
              <dd id={panelId} className={isOpen ? 'pb-7' : 'hidden'} data-id="element-347" data-mp="2grunrs6cu129">
                <p className="max-w-prose text-[16px] leading-relaxed text-body" data-id="element-348" data-mp="2goynhx71b0an">{item.answer}</p>
              </dd>
            </div>;
      })}
      </dl>
    </Section>;
}